import React from 'react'
import { formatValueV2 } from '../../helpers/funcs'
import Placeholder from '../misc/placeholder'
import SectionTableVertical from './SectionTableVertical'

const formatColumnValue = (col, row) => {
    if (col.maxLength) {
        return row[col.id || col.label].substr(0, col.maxLength) + (row[col.id || col.label].length > col.maxLength ? '...' : '')
    }
    if (col.format) {
        return formatValueV2(row[col.id || col.label])
    }
    return row[col.id || col.label]
}

const SectionTableList = (props) => {
    const { data, cols, id, Subtitle } = props
    return data ? (
        <React.Fragment>
            {id && (
                <a id={id} href="/" className="anchor">&nbsp;</a>
            )}
            <SectionTableVertical data={data} cols={cols} labelCol="Country" Title={props.Title} Subtitle Total={true} />
            <section className="section d-none d-sm-block">
                <h3 className="section-header">{props.Title || 'List'}{props.Total && ` (${data ? data.length : 0})`}
                    {Subtitle && (
                        <React.Fragment>
                            <br />
                            <small className="subtitle">{Subtitle}</small>
                        </React.Fragment>
                    )}
                </h3>
                <div className="table-responsive">
                    {data && data.length && cols ? (
                        <table className="table table-hover table-striped">
                            <thead>
                                <tr>
                                    {cols.filter(c => !c.ownRow).map((col, idx) => (
                                        <th style={{ maxWidth: col.maxWidth || 'initial' }} className={`text-${col.align || 'left'} ${col.nowrap ? 'nowrap' : ''}`} key={idx}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((row, idx) => (
                                    <React.Fragment key={`r-${idx}`}>
                                        {cols.filter(col => col.ownRow).length ? (
                                            <tr>
                                                {cols.filter(col => col.ownRow).map((col, idx3) => (
                                                    <td key={`rr-${idx3}`} colSpan={idx3 === 0 ? 1 : (cols.length - cols.filter(col => col.ownRow).length - 1)}>
                                                        {col.preIcon ? <i className={`fas ${col.preIcon}`} /> : null}{formatColumnValue(col, row)}
                                                    </td>
                                                ))}
                                            </tr>
                                        ) : null}
                                        <tr>
                                            {cols.filter(col => !col.ownRow).map((col, idx2) => (
                                                <td style={{ maxWidth: col.maxWidth || 'initial' }} className={`text-${col.align || 'left'} ${col.nowrap ? 'nowrap' : ''}`} key={`c-${idx2}`}>{formatColumnValue(col, row)}</td>
                                            ))}
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                            {cols.filter(col => col.totalize).length ? (
                                <tfoot>
                                    <tr className="bg-dark color-white">
                                        <th>Total</th>
                                        {cols.filter((col, idx) => idx > 0 || !col.ownRow).map((col, idx) => (
                                            <React.Fragment key={`t-${idx}`}>
                                                {!col.ownRow && idx > 0 ? (
                                                    <th data-title={col.label} className={`text-${col.align || 'left'} ${col.nowrap ? 'nowrap' : ''}`} >{col.totalize ?
                                                        formatValueV2(data.reduce((acum, obj) => {
                                                            return acum + +obj[col.id || col.label]
                                                        }, 0), '$0,0.00') : ''}
                                                    </th>
                                                ) : null}
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </tfoot>
                            ) : null}
                        </table>
                    ) : (
                            <p>No data for this category.</p>
                        )}
                </div>
            </section>
        </React.Fragment>
    ) : <Placeholder />
}

export default SectionTableList